function TiktokWhite() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <g clipPath="url(#clip0_3710_15099)">
        <path
          d="M16.5293 -0.000640869C18.4459 -0.000640869 20 1.55347 20 3.47006V16.5287C20 18.4453 18.4459 19.9994 16.5293 19.9994H3.4707C1.55411 19.9994 0 18.4453 0 16.5287V3.47006C0 1.55347 1.55411 -0.000640869 3.4707 -0.000640869H16.5293ZM10.377 12.8324C10.3571 13.3915 10.1212 13.9213 9.71875 14.3099C9.31616 14.6985 8.77829 14.9163 8.21875 14.9164C7.03542 14.9164 6.05176 13.9494 6.05176 12.7494C6.05176 11.316 7.43535 10.2413 8.86035 10.683V8.04916C5.98539 7.66589 3.46875 9.89939 3.46875 12.7494C3.46875 15.5242 5.76846 17.4991 8.20996 17.4994C10.8266 17.4994 12.9521 15.3744 12.9521 12.7494V7.50815C13.9962 8.25785 15.2498 8.65971 16.5352 8.65756V6.08237C16.5128 6.08337 14.9601 6.14784 13.835 4.84897C13.2656 4.19872 12.9519 3.36369 12.9521 2.49936H10.377V12.8324Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_3710_15099">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default TiktokWhite;
